var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import * as Sentry from '@sentry/react';
import SFText from '../SFText';
import ErrorBoundaryImg from '../../img/error-boundary.svg';
import ReloadIcon from '../../img/reload.svg';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var FlexBox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var ErrorFallback = function () {
    return (_jsxs(Wrapper, { children: [_jsx("img", { style: { marginTop: '112px' }, src: ErrorBoundaryImg, alt: "" }), _jsx(SFText, __assign({ mt: "24px", fontWeight: "600", fontSize: "24px", lineHeight: "24px", color: "grey50" }, { children: "Looks Like" })), _jsx(SFText, __assign({ mt: "16px", mb: "24px", fontWeight: "600", fontSize: "24px", lineHeight: "24px", color: "grey50" }, { children: "Something Went Wrong..." })), _jsxs(FlexBox, { children: [_jsx("img", { src: ReloadIcon, alt: "" }), _jsx(SFText, __assign({ ml: "8px", level: 2, fontWeight: "600", color: "grey50" }, { children: "You can manually reload the page." }))] })] }));
};
var SentryErrorBoundary = function (_a) {
    var children = _a.children;
    return (_jsx(Sentry.ErrorBoundary, __assign({ fallback: _jsx(ErrorFallback, {}) }, { children: children })));
};
export default SentryErrorBoundary;
var templateObject_1, templateObject_2;
